module.exports = __webpack_public_path__ + "static/media/Banjo1.75d57926.jpg";